// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"228":"87ddef45","884":"1a8a55e5","951":"19b93074"}[chunkId] + ".js";
};